export function displayShareModal (shareURL) {
  document.getElementById('share-modal-url').textContent = shareURL

  const shareModal = document.getElementById('share-modal')
  shareModal.style.display = 'block'

  document.getElementById('close-share-modal').addEventListener('click', () => {
    shareModal.style.display = 'none'
  })
  window.onclick = (event) => {
    if (event.target === shareModal) {
      shareModal.style.display = 'none'
    }
  }
}
